import Coaching from './coaching'
import Server from './server'

export default ctx => {
  const coaching = Coaching(ctx)
  const server = Server(ctx)

  return {
    coaching,
    server,
  }
}
